<template>
    <rkm-form
        ref="Form"
    >

        <rkm-area
            title="Fator"
            type="fieldset"
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-checkbox v-model="model.faturamento">
                        Faturamento
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-checkbox
                        v-model="model.auxilioAlimentacao"
                        :disabled="!model.faturamento"
                    >
                        Auxílio alimentação
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.faturamento"
            title="Dados"
            type="fieldset"
        >
            <FormFaturamento
                ref="FormFaturamento"
                :form="form"
                :model="model"
            />
        </rkm-area>
    </rkm-form>
</template>

<script>

// Components.
import FormFaturamento from './components/Form'

export default {
    components: { FormFaturamento },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.faturamento': function (value) {

            if (!value) {

                this.model.auxilioAlimentacao = null
            }
        }
    },
}
</script>